<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header">
          <i class="fas fas-align-justify"></i>
          Plan
        </div>
        <div class="card-body p-5">
          <div class="row">
            <div class="btn btn-primary col-1 mb-3" [routerLink]="['/quotes/', plan.quoteId]">Back To Quote</div>
          </div>
          <div class="row mb-3">
            <img src="{{planImage?.imageUrl}}" alt="img" class="mb-3">
          </div>
          <hr class="mt-3">
          <h4>Specifications</h4>
          <hr>
          <div class="row">
            <div *ngFor="let i of this.plan?.planSpecifications">
                <div class="row">
                    <div class="col">{{ i.specificationAnswer?.specificationQuestion?.text }}</div>
                    <div class="col">
                      {{ i.specificationAnswer?.text }}
                    </div>
                </div>
              <hr>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
